import type { TracerProvider } from '@opentelemetry/api';
import type { SpanProcessor } from '@opentelemetry/sdk-trace-base';
import type { SpanAttribute, CustomSpan, StartSpanParams, StartActiveSpanParams } from '../entities';
import { ObservabilitySystem } from '../interfaces';

export class ObservabilitySystemDecorator implements ObservabilitySystem {
  constructor(private readonly observabilitySystem: ObservabilitySystem) {}

  setGlobalTracerProvider(provider: TracerProvider): boolean {
    return this.observabilitySystem.setGlobalTracerProvider(provider);
  }

  getTracerProvider(): TracerProvider {
    return this.observabilitySystem.getTracerProvider();
  }

  addSpanProcessor(spanProcessor: SpanProcessor): void {
    return this.observabilitySystem.addSpanProcessor(spanProcessor);
  }

  startActiveSpan<F extends (span: CustomSpan) => ReturnType<F>>(params: StartActiveSpanParams<F>): ReturnType<F> {
    return this.observabilitySystem.startActiveSpan<F>(params);
  }

  setAttributes(attributes: Record<string, SpanAttribute>): ObservabilitySystem {
    return this.observabilitySystem.setAttributes(attributes);
  }

  getAttributes(): Record<string, SpanAttribute> {
    return this.observabilitySystem.getAttributes();
  }

  startSpan(params: StartSpanParams): CustomSpan {
    return this.observabilitySystem.startSpan(params);
  }
}
